import { useCallback } from "react";

type UsePostcodeOptions = {
  containerRef: React.RefObject<HTMLDivElement>;
  onComplete: (data: { address: string; zonecode: string }) => void;
};

/**
 * Custom hook to open the Daum Postcode search widget in a given container.
 * - Embeds the widget into the specified container.
 * - Triggers `onComplete` with the selected address and zonecode.
 * - Automatically handles container height adjustment and hiding after selection.
 */
const usePostcode = ({ containerRef, onComplete }: UsePostcodeOptions)=> {
  const openPostcode = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;

    new window.daum.Postcode({
      oncomplete: (data: any) => {
        onComplete({
          address: data.address,
          zonecode: data.zonecode,
        });

        container.innerHTML = "";
        container.style.display = "none";
      },
      onresize: (size: { width: number; height: number }) => {
        container.style.height = `${size.height}px`;
      },
      width: "100%",
      height: "100%",
    }).embed(container);

    container.style.display = "block";
  }, [containerRef, onComplete]);

  return { openPostcode };
}

export default usePostcode;